import { API_ROOT } from './constants/';
import urlWithParams from './utils/urlWithParams';

export const getBranding = async (uuid) => {
  const method = 'GET';
  const endpoint = `${API_ROOT}/branding/paywall/${uuid}/default`;

  const response = await fetch(endpoint, { method });

  return await response.json();
};

export const getAssets = async (uuid, mediaspace) => {
  const { localStorage } = window;

  const { token } = JSON.parse(localStorage.getItem('inplayer_token') || '{}');

  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const withToken = token ? '/token' : '';

  const method = 'GET';
  const endpoint = urlWithParams(
    `${API_ROOT}/items/kaltura/mediaspace/${uuid}${withToken}`,
    {
      mediaspace,
      limit: 100,
      rand: Math.random(),
    }
  );

  const response = await fetch(endpoint, { method, headers });

  return await response.json();
};
